import userActions from "./userActions";

const allActions = {    
    userActions
}

export default allActions